import { Component, computed, effect, inject, input, signal } from "@angular/core";
import { SubscriptionService } from "../../../services/subscriptionservice";
import { ProductType } from "../../../gql/generated-ingestor";
import { AngularSvgIconModule } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";
import { StatusToIconPipe } from "../../../helpers/statusiconpipe/statusiconpipe";
import { ServiceSpeedPipe } from "../../../pages/subscription-detail/components/service-speed-pipe/service-speed-pipe";

export interface ServiceType {
  subscriptionId?: string;
  customerDescription?: string;
  organisation?: string;
  portSpeed?: number;
  product?: ProductType;
  patchPosition?: string;
  ieeeInterfaceType?: string;
}

@Component({
  selector: "port-tile",
  templateUrl: "port-tile.html",
  styleUrls: ["../port-visualiser/port-visualiser.scss"],
  imports: [TranslateModule, AngularSvgIconModule, ServiceSpeedPipe, StatusToIconPipe],
})
export class PortTile {
  private subscriptionService = inject(SubscriptionService);

  protected service = input.required<ServiceType>();
  protected healthState = signal("");

  protected portOwner = computed(() => this.service().organisation);
  protected customerDescription = computed(() => this.service().customerDescription);

  protected portSpeed = computed(() => this.service().portSpeed);
  protected patchPosition = computed(() => this.service().patchPosition);
  protected interfaceType = computed(() => this.service().ieeeInterfaceType);

  private healthStateEffect = effect(() => {
    const subscriptionId = this.service().subscriptionId;
    this.subscriptionService.getHealthDataForSubscription(subscriptionId).then((status) => {
      this.healthState.set(status.status);
    });
  });
}
